<template>
  <div>
    <b-row>
      <b-col>
        You must provide information about yourself and the subject of the record to ensure we can fulfill your order. Some requests require that you present a form of
        identification, and those requests must be notarized if submitted online or via mail or fax.
        (<a href="https://www.revisor.mn.gov/rules/4601.2600/" class="mdh-green-link" target="_blank">Minnesota Rules 4601.2600 - opens in new tab</a>).
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        If we can't locate the record with the information you provide, we'll send you a letter and a Statement of No Record Found.
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        Some records and products are only available to eligible requesters. Your eligibility and access depends on both the public/confidential status and your
        relationship to the subject of the vital record
        (<a href="https://www.revisor.mn.gov/statutes/cite/144.225" class="mdh-green-link" target="_blank">Minnesota Statutes, section 144.225, subdivisions 2 and 7 - opens in new tab</a>).
        We will determine your eligibility when we review your order. We’ll send you a letter if you are ineligible to get what you ordered.
        Learn more: <a href="https://www.health.state.mn.us/people/vitalrecords/tangible.html" class="mdh-green-link" target="_blank">Who Can Order Records (opens in new tab)</a>.
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        Providing false information to obtain or amend a vital record is illegal and may subject you to fines, jail time, or both. Anyone who illegally counterfeits,
        alters, obtains, uses, or sells a vital record, report, or certificate would be guilty of a gross misdemeanor
        (<a href="https://www.revisor.mn.gov/statutes/cite/144.227" class="mdh-green-link" target="_blank">Minnesota Statutes 144.227 - opens in new tab</a>).
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        We allow up to 12 months for you to resolve an incomplete order, such as those without proper notarization or documentation.
        Once we close a request, you must submit a new order and payment.
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        Fees are non-refundable even if we can’t locate a record or otherwise fulfill your order.
        (<a href="https://www.revisor.mn.gov/statutes/cite/144.226" class="mdh-green-link" target="_blank">Minnesota Statutes 144.226 - opens in new tab</a>).
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        Anyone who illegally counterfeits, alters, obtains, uses, or sells a vital record, report, or certificate would be guilty of a gross misdemeanor.
        (<a href="https://www.revisor.mn.gov/statutes/cite/144.227" class="mdh-green-link" target="_blank">Minnesota Statutes 144.227 - opens in new tab</a>)
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.mdh-green-link, .mdh-green-link:hover, .mdh-green-link:focus {
  color: #3D792A;
  text-decoration: underline;
}
</style>
